import FacebookIcon from "./FacebookIcon";
import InstagramIcon from "./InstagramIcon";
import LinkedinIcon from "./LinkedinIcon";
import TiktokIcon from "./TiktokIcon";
import TwitterIcon from "./TwitterIcon";

export { FacebookIcon, InstagramIcon, LinkedinIcon, TiktokIcon, TwitterIcon };
